export default "__VITE_ASSET__MEGKf5Yh__"